function isFn(value) {
  const type = Object.prototype.toString.call(value);
  return type === '[object Function]';
}
function isNode(value) {
  return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
}

export function listenNode(node, type, callback) {
  node.addEventListener(type, callback);
  return {
    destroy() {
      node.removeEventListener(type, callback);
    },
  };
}

function addListener(target, type, callback) {
  if (!target && !type && !callback) {
    throw new Error('缺少参数');
  }
  if (!isFn(callback)) {
    throw new TypeError('第三个参数是回调函数');
  }
  if (isNode(target)) {
    return listenNode(target, type, callback);
  }
  throw new TypeError('第一个参数是dom元素');
}

function listenNodeList(nodeList, type, callback) {
  Array.prototype.forEach.call(nodeList, node => {
    node.addEventListener(type, callback);
  });

  return {
    destroy() {
      Array.prototype.forEach.call(nodeList, node => {
        node.removeEventListener(type, callback);
      });
    },
  };
}

export default {
  listenNode,
  listenNodeList
}
